import { Pipe, PipeTransform } from '@angular/core';
import {
  DateTimeService,
  MOMENT_AM_PM_TIME_FORMAT,
  MOMENT_FULL_AM_PM_TIME_FORMAT,
} from 'i2g-ng-utils';

@Pipe({
  name: 'amPmTime',
})
export class AmPmTimePipe implements PipeTransform {
  constructor(private _dateTimeService: DateTimeService) {}

  transform(dateTime: string, fullTime?: boolean): string {
    return this._dateTimeService.formatDate(
      dateTime,
      fullTime ? MOMENT_FULL_AM_PM_TIME_FORMAT : MOMENT_AM_PM_TIME_FORMAT
    );
  }
}
